import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from './store';
import { getApiUrl } from '../lib/utils';

// Read tenant from env (set VITE_TENANT_ID in .env for each deployment)
const TENANT_ID = import.meta.env.VITE_TENANT_ID || 'ayursangrah';

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl(),
    prepareHeaders: (headers, { getState }) => {
      // Dynamic tenant ID — no longer hardcoded
      headers.set('x-tenant-id', TENANT_ID);

      // Attach JWT if logged in
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['User', 'AcademicYear', 'Subject', 'Chapter', 'Video', 'Note', 'Test', 'Question', 'WeeklyTest', 'Settings', 'Dashboard', 'Carousel', 'Plan', 'Order', 'Dictionary', 'ChatGroup', 'ChatMember', 'ChatMessage', 'ExploreDriveResource', 'ExploreDictionaryTerm', 'ExploreDravyagunaHerb', 'ExploreChikitsaProtocol', 'ExploreSubmission'],
  keepUnusedDataFor: 300, // 5 minutes — admin content rarely changes; reduces DB hits
  endpoints: () => ({}),
});
